import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['deleteButton'];

  static outlets = ['components--admin-data-table'];

  static values = {
    modalTitle: String,
    modalMessageOne: String,
    modalMessageOther: String,
    modalConfirm: String,
    modalCheckboxConfirmMessageOne: String,
    modalCheckboxConfirmMessageOther: String,
    filterParams: Object
  }

  connect() {
    this.deleteButtonTarget.addEventListener('click', this._deleteUsers.bind(this));

    this._boundSyncDeleteButton = this._syncDeleteButton.bind(this);
    document.addEventListener('promote:data-table:selection', this._boundSyncDeleteButton);
  }

  disconnect() {
    document.removeEventListener('promote:data-table:selection', this._boundSyncDeleteButton);
  }

  _deleteUsers(event) {
    if (Rails.confirm(null, event.target, this._deleteModelDataset())) {
      this._sendDeleteRequest();
    }
  }

  _syncDeleteButton() {
    if (this.hasComponentsAdminDataTableOutlet) {
      const { selectionMode, selectedItems } = this.selectionData;

      this._setDisabledStateDeleteButton(
        (selectionMode === 'specific' && selectedItems.size === 0) || selectionMode === 'none'
      );
    } else {
      this._setDisabledStateDeleteButton(true);
    }
  }

  _deleteModelDataset() {
    const { selectedItems, selectionMode, totalCount } = this.selectionData;

    let selectedCount;

    // TODO: Wonder if this is responsability of the DataTable controller
    // to answer?
    if (selectionMode === 'specific') {
      selectedCount = selectedItems.size;
    } else if (selectionMode === 'all_except') {
      selectedCount = totalCount - selectedItems.size
    } else if (selectionMode === 'all') {
      selectedCount = totalCount;
    } else {
      // Should never get here tho
      selectedCount = 0;
    }
    
    return {
      confirmError: true,
      confirmAllow: this.modalConfirmValue,
      confirmMessage: selectedCount === 1 ?
        this.modalMessageOneValue :
        this.modalMessageOtherValue.replace('0', selectedCount),
      confirmTitle: this.modalTitleValue,
      confirmCheck: 'true',
      confirmCheckMessage: selectedCount === 1 ?
        this.modalCheckboxConfirmMessageOneValue :
        this.modalCheckboxConfirmMessageOtherValue.replace('0', selectedCount)
    };
  }

  _sendDeleteRequest() {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    let formData = new FormData();
    const { selectionMode, selectedItems } = this.selectionData;

    formData.append('selected_items', Array.from(selectedItems.keys()).join(','));
    formData.append('selection_mode', selectionMode);

    // Forward filter parameters to ensure correct scope reconstruction
    // This is critical for 'all' and 'all_except' modes to work correctly
    if (this.hasFilterParamsValue) {
      const filterParams = this.filterParamsValue;
      for (const [key, value] of Object.entries(filterParams)) {
        if (value !== null && value !== undefined && value !== '') {
          formData.append(key, value);
        }
      }
    }

    Rails.ajax({
      url: '/admin/bulk_user_deletions',
      type: "DELETE",
      dataType: "script",
      data: formData,
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      },
      success: () => {
      },
    });
  }

  _setDisabledStateDeleteButton(isDisabled) {
    this.deleteButtonTarget.disabled = isDisabled;
  }

  get selectionData() {
    if (this.hasComponentsAdminDataTableOutlet) {
      const {
        selectionMode,
        selectedItems,
        totalCount
      } = this.componentsAdminDataTableOutlet.state

      return {
        selectionMode,
        selectedItems,
        totalCount
      }
    } else {
      return {
        selectionMode: 'none',
        selectedItems: new Set(),
        totalCount: 0
      }
    }
  }
}
